import { styled } from "styled-components";

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.default[300]};
`;

export const MenuContainer = styled.div`
  display: flex;
  width: 296px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
    max-width: 90vw;
    flex: 1 0 0;
  }
`;

export const MenuItemsContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
`;

export const MenuItems = styled.div`
  display: flex;
  padding-bottom: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: row;
    gap: 12px;
  }
`;

export const MenuItem = styled.div<{ $active: boolean }>`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 8px;
  width: 100%;
  border-radius: 12px;
  cursor: pointer;
  background-color: ${({ theme, $active }) =>
    $active ? theme.colors.default[50] : "transparent"};

  transition: color 0.2s ease-in-out;

  ${({ theme }) => theme.breakpoints.md.query} {
    background-color: "transparent";
    flex-shrink: 0;
    width: fit-content;
    &:hover {
      color: ${({ theme }) => theme.colors.default[400]};
    }
  }

  & > a {
    width: 100%;
    height: 100%;
  }
`;
